import { ClaimFinancials } from '../claim-details/claim-financials';

export interface ClaimFinancialSummaryData {
    charge: number;
    contractValue: number;
    allowed: number;
    payerPaid: number;
    patientResponsibility: number;
    patientPaid: number;
    outstanding: number;
}

const round2 = (value: number): number => Math.round(value * 100) / 100;

export const toClaimFinancialSummary = (financials: ClaimFinancials): ClaimFinancialSummaryData => {
    const contractValue = round2(financials.contracted || 0);
    const payerPaid = round2(financials.payerPaid);
    const patientPaid = round2(financials.patientPaid);

    return {
        charge: round2(financials.charge || 0),
        contractValue,
        allowed: round2(financials.payerAllowed || 0),
        payerPaid,
        patientResponsibility: round2(financials.patientResponsibility),
        patientPaid,
        outstanding: round2(Math.max(0, contractValue - payerPaid - patientPaid)),
    };
};
